import Select from './Select'
import CharacterClassIcon from './CharacterClassIcon'
import CharacterClass, {
  classColours,
} from 'app/frontend/types/custom/CharacterClass'
import { useCharacterClasses } from '../hooks/useCharacterClasses'
import { cn } from '@/lib/utils'

interface Props {
  value?: CharacterClass
  setValue: (value: CharacterClass | undefined) => void
  inModal?: boolean
  disabled?: boolean
  className?: string
  style?: React.CSSProperties
}

const CharacterClassSelect = ({
  value,
  setValue,
  inModal = false,
  disabled,
  className,
  style,
}: Props) => {
  const characterClasses = useCharacterClasses()

  return (
    <Select
      value={value}
      setValue={(selected) => setValue(selected as CharacterClass | undefined)}
      options={characterClasses.map((characterClass) => ({
        value: characterClass,
        label: (
          <span
            className={cn(
              'flex items-center gap-2',
              classColours[characterClass].text,
            )}
          >
            <CharacterClassIcon characterClass={characterClass} />
            {characterClass}
          </span>
        ),
        sortLabel: characterClass,
      }))}
      isSearchable={false}
      inModal={inModal}
      disabled={disabled}
      className={className}
      style={style}
      placeholder='Select class'
    />
  )
}

export default CharacterClassSelect
